(() => {
  'use strict';

  const shoppingData = JSON.parse(document.getElementById('bbs-shopping-data')?.textContent || '{}');
  const sizeCodes = {'4"':'four','5.25"':'five','6.5"':'six','6x9"':'sixnine','7.7"':'seven','8"':'eight','3.5"':'tweeter'};
  const platformCodes = {'1800':'apache-1800','2800':'apache-2800','3800':'apache-3800','Apache 4800':'apache-4800','Vault V100':'vault','Vault V300':'vault','BBS Nexus':'universal','LED Cooler':'universal'};
  shoppingData.fitment = (shoppingData.fitment || []).flatMap(item => {
    const platforms = item.part === 'Grille' ? ['grilles'] : [...new Set((item.platforms || []).map(p => platformCodes[p]).filter(Boolean))];
    return platforms.map(platform => ({...item, platform, size:[...(item.sizes || []).map(s => sizeCodes[s]).filter(Boolean), ...(item.part === 'Grille' ? ['grille'] : [])], models:[], fit:[...(item.platforms || []), ...(item.sizes || [])].join(' · ')}));
  });
  const copy = shoppingData.labels || {};
  const path = window.location.pathname.replace(/\/+$/, '') || '/';

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function createElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }

  function addPageClass() {
    if (path === '/') document.body.classList.add('bbs-home');
    if (path === '/pages/fitment-center') document.body.classList.add('bbs-fitment-page');
    if (path.startsWith('/products/')) document.body.classList.add('bbs-product-page');
    if (path.startsWith('/collections/')) document.body.classList.add('bbs-collection-page');
    if (path === '/cart') document.body.classList.add('bbs-cart-page');
  }

  function addHomeProofStrip() {
    if (path !== '/' || document.querySelector('.bbs-proof-strip')) return;
    const firstSection = document.querySelector('#MainContent > .shopify-section');
    if (!firstSection) return;

    const strip = createElement('section', 'bbs-proof-strip');
    strip.setAttribute('aria-label', 'Why customers choose Bang Box Speakerz');
    ['Built by BBS', 'Fitment help from real builders', 'Secure checkout'].forEach((label) => {
      strip.append(createElement('div', 'bbs-proof-strip__item', label));
    });
    firstSection.after(strip);
  }

  function addProductAssurance() {
    if (!path.startsWith('/products/') || document.querySelector('.bbs-product-assurance')) return;
    const productForm = document.querySelector('product-form.product-form, .product-form');
    if (!productForm) return;

    const assurance = createElement('div', 'bbs-product-assurance');
    assurance.setAttribute('aria-label', 'Order support');
    ['Fitment help available', 'Shipping shown at checkout', 'RGV pickup option'].forEach((label) => {
      assurance.append(createElement('div', 'bbs-product-assurance__item', label));
    });
    productForm.after(assurance);
  }

  function addStickyAddToCart() {
    if (!path.startsWith('/products/') || document.querySelector('.bbs-sticky-atc')) return;
    const originalButton = document.querySelector('.product-form__submit');
    if (!originalButton) return;

    const title = document.querySelector('.product__title h1')?.textContent?.trim() || 'Selected product';
    const priceElement = document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');
    const sticky = createElement('aside', 'bbs-sticky-atc');
    sticky.setAttribute('aria-label', 'Quick add to cart');

    const summary = createElement('div', 'bbs-sticky-atc__summary');
    summary.append(createElement('div', 'bbs-sticky-atc__title', title));
    summary.append(createElement('div', 'bbs-sticky-atc__price', priceElement?.textContent?.trim() || ''));

    const button = createElement('button', 'button button--primary bbs-sticky-atc__button', originalButton.textContent.trim());
    button.type = 'button';
    button.disabled = originalButton.disabled;
    button.addEventListener('click', () => originalButton.click());
    sticky.append(summary, button);
    document.body.append(sticky);

    const syncButton = () => {
      button.textContent = originalButton.textContent.trim();
      button.disabled = originalButton.disabled;
      const currentPrice = document.querySelector('.product__info-container .price .price-item--sale, .product__info-container .price .price-item--regular');
      const stickyPrice = sticky.querySelector('.bbs-sticky-atc__price');
      if (currentPrice && stickyPrice) stickyPrice.textContent = currentPrice.textContent.trim();
    };

    new MutationObserver(syncButton).observe(originalButton, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-hidden', entry.isIntersecting);
      }, { threshold: 0.35 });
      observer.observe(originalButton);
    }
  }

  function collectFitmentPlatforms(root) {
    return [...root.querySelectorAll('h2[id]')].map((heading) => {
      const products = [];
      let node = heading.nextSibling;
      while (node) {
        if (node.nodeType === Node.ELEMENT_NODE && (node.matches('hr') || node.matches('h2'))) break;
        if (node.nodeType === Node.ELEMENT_NODE) {
          const links = node.matches('h3') ? [...node.querySelectorAll('a[href*="/products/"]')] : [];
          links.forEach((link) => products.push({
            title: link.textContent.trim(),
            href: link.getAttribute('href'),
          }));
        }
        node = node.nextSibling;
      }
      const catalogProducts = (shoppingData.fitment || []).filter(item => item.platform === heading.id);
      return { id: heading.id, label: heading.textContent.trim(), heading, products: catalogProducts.length ? catalogProducts : products };
    });
  }

  function fitmentMatchesNeed(title, need) {
    const value = title.toLowerCase();
    const tests = {
      all: () => true,
      four: () => /(^|\s|\")4(\"|\s|-)/.test(value) || value.includes('4 pro'),
      five: () => value.includes('5.25'),
      six: () => value.includes('6.5') || value.includes('6-5'),
      sixnine: () => value.includes('6x9'),
      eight: () => /(^|\s|\")8(\"|\s|-)/.test(value),
      tweeter: () => value.includes('tweeter'),
      grille: () => value.includes('grill'),
    };
    return (tests[need] || tests.all)();
  }

  function buildFitmentFinder(root, platforms) {
    if (document.querySelector('.bbs-fitment-tool')) return;
    const howTo = [...root.querySelectorAll('h2')].find((heading) => /how to verify fitment/i.test(heading.textContent));
    if (!howTo) return;

    const finder = createElement('section', 'bbs-fitment-tool');
    finder.setAttribute('aria-labelledby', 'bbs-fitment-tool-title');
    finder.innerHTML = `
      <p class="bbs-fitment-tool__eyebrow">Start here</p>
      <h2 id="bbs-fitment-tool-title">Find parts that match your build</h2>
      <p class="bbs-fitment-tool__intro">${copy.finder_intro}</p>
      <div class="bbs-fitment-tool__controls">
        <label class="bbs-fitment-field">
          Box or platform
          <select data-bbs-fitment-platform>
            <option value="">Select your box</option>
          </select>
        </label>
        <label class="bbs-fitment-field">
          Speaker or part
          <select data-bbs-fitment-need>
            <option value="all">All matching parts</option>
            <option value="four">4-inch</option>
            <option value="five">5.25-inch</option>
            <option value="six">6.5-inch</option>
            <option value="sixnine">6x9-inch</option>
            <option value="seven">7.7-inch</option><option value="eight">8-inch</option>
            <option value="tweeter">Tweeter</option>
            <option value="grille">Speaker grilles</option>
          </select>
        </label>
        <label class="bbs-fitment-field">${copy.model_label}<select data-bbs-fitment-model><option value="">${copy.all_models}</option></select></label>
        <button type="button" class="button button--primary bbs-fitment-tool__button">Show matching parts</button>
      </div>
      <div class="bbs-fitment-results" role="status" aria-live="polite" hidden></div>
    `;

    const platformSelect = finder.querySelector('[data-bbs-fitment-platform]');
    platforms.forEach((platform) => {
      const option = document.createElement('option');
      option.value = platform.id;
      option.textContent = platform.label;
      platformSelect.append(option);
    });

    const modelSelect = finder.querySelector('[data-bbs-fitment-model]');
    const models = [...new Set((shoppingData.fitment || []).flatMap(item => item.models))].sort();
    models.forEach(model => { const option = new Option(model, model); modelSelect.append(option); });
    modelSelect.append(new Option(copy.dimension_choice, '__dimensions'));
    if (!models.length) modelSelect.closest('label').hidden = true;
    const renderResults = () => {
      const platform = platforms.find((item) => item.id === platformSelect.value);
      const need = finder.querySelector('[data-bbs-fitment-need]').value;
      const results = finder.querySelector('.bbs-fitment-results');
      results.hidden = false;
      results.replaceChildren();

      if (!platform) {
        results.append(createElement('p', 'bbs-fitment-results__title', 'Choose a box or platform to see matching parts.'));
        platformSelect.focus();
        return;
      }

      const matches = platform.products.filter((product) => (need === 'all' || (product.size ? product.size.includes(need) : fitmentMatchesNeed(product.title, need))) && (!modelSelect.value || (modelSelect.value === '__dimensions' ? !product.models?.length : product.models?.includes(modelSelect.value))));
      const heading = createElement('h3', 'bbs-fitment-results__title', matches.length ? `${copy.model_count}: ${matches.length}` : copy.no_match);
      results.append(heading);
      if (matches.length) results.append(createElement('p', 'bbs-fitment-note', copy.result_note));

      if (!matches.length) {
        const message = document.createElement('p');
        message.append('Try another size or ');
        const contact = document.createElement('a');
        contact.href = '/pages/contact';
        contact.textContent = 'ask BBS to verify your setup';
        message.append(contact, '.');
        results.append(message);
        return;
      }

      const list = createElement('ul', 'bbs-fitment-results__list');
      matches.forEach((product) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = product.href;
        link.textContent = product.title;
        link.dataset.bbsMatchLabel = product.models?.length ? copy.named : copy.dimension;
        link.dataset.bbsFitDetail = [product.fit, product.measure, product.note].filter(Boolean).join(' • ');
        item.append(link);
        list.append(item);
      });
      results.append(list);
    };

    modelSelect.addEventListener('change', () => { if (platformSelect.value) renderResults(); });
    finder.querySelector('.bbs-fitment-tool__button').addEventListener('click', renderResults);
    finder.querySelector('[data-bbs-fitment-need]').addEventListener('change', () => {
      if (platformSelect.value) renderResults();
    });
    platformSelect.addEventListener('change', () => {
      if (platformSelect.value) renderResults();
    });
    howTo.before(finder);
  }

  function buildFitmentChips(root, platforms) {
    if (document.querySelector('.bbs-fitment-chips')) return;
    const howTo = [...root.querySelectorAll('h2')].find((heading) => /how to verify fitment/i.test(heading.textContent));
    if (!howTo) return;
    const chips = createElement('nav', 'bbs-fitment-chips');
    chips.setAttribute('aria-label', 'Jump to a fitment section');
    platforms.forEach((platform) => {
      const link = document.createElement('a');
      link.href = `#${platform.id}`;
      link.textContent = platform.label;
      chips.append(link);
    });
    howTo.before(chips);
  }

  function buildFitmentAccordions(platforms) {
    platforms.forEach((platform, index) => {
      const heading = platform.heading;
      if (!heading.isConnected) return;

      const details = createElement('details', 'bbs-fitment-group');
      details.id = platform.id;
      if (index === 0) details.open = true;
      const summary = createElement('summary', '', platform.label);
      const content = createElement('div', 'bbs-fitment-group__content');
      details.append(summary, content);
      heading.before(details);

      let node = heading.nextSibling;
      heading.remove();
      while (node) {
        if (node.nodeType === Node.ELEMENT_NODE && (node.matches('hr') || node.matches('h2'))) break;
        const next = node.nextSibling;
        content.append(node);
        node = next;
      }
      if (node?.nodeType === Node.ELEMENT_NODE && node.matches('hr')) node.remove();
    });

    document.addEventListener('click', (event) => {
      const chip = event.target.closest('.bbs-fitment-chips a');
      if (!chip) return;
      const details = document.querySelector(chip.getAttribute('href'));
      if (details?.matches('details')) details.open = true;
    });
  }

  function enhanceFitmentCenter() {
    if (path !== '/pages/fitment-center') return;
    const root = document.querySelector('#MainContent .rte');
    if (!root) return;
    const platforms = collectFitmentPlatforms(root);
    if (!platforms.length) return;
    buildFitmentFinder(root, platforms);
    buildFitmentChips(root, platforms);
    buildFitmentAccordions(platforms);
  }

  function addCollectionCategoryBar() {
    if (path !== '/collections/all' || document.querySelector('.bbs-category-bar')) return;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('sort_by')) {
      params.set('sort_by', 'best-selling');
      window.location.replace(`${path}?${params.toString()}${window.location.hash}`);
      return;
    }

    const main = document.querySelector('#MainContent');
    const anchor = main?.querySelector('.collection-hero, .facets-wrapper, .facets-container');
    if (!main || !anchor) return;
    const bar = createElement('nav', 'bbs-category-bar');
    bar.setAttribute('aria-label', 'Shop product categories');
    bar.innerHTML = `
      <p class="bbs-category-bar__title">Shop by category</p>
      <div class="bbs-category-bar__links">
        <a href="/collections/bbs-pro-audio-speakerz">Portable builds</a>
        <a href="/collections/pro-audio-speakerz">Pro audio speakers</a>
        <a href="/collections/bbs-spacers-%F0%9F%98%88">Spacers &amp; faceplates</a>
        <a href="/collections/bbs-grillz-%F0%9F%98%8E%F0%9F%94%8A">Speaker grilles</a>
        <a href="/collections/bbs-amp-cases">Amp cases</a>
        <a href="/collections/bbs-merch">Merchandise</a>
      </div>
    `;
    anchor.after(bar);
  }

  function cartAssuranceMarkup() {
    const wrapper = createElement('div', 'bbs-cart-assurance');
    wrapper.innerHTML = `
      <strong>RGV local pickup available</strong>
      <p>Pickup is only for customers who can collect in Donna, Texas. You will confirm your delivery choice before checkout.</p>
      <p class="bbs-cart-assurance__meta">Shipping options at checkout · Secure payment · Fitment help available</p>
      <button type="button" class="link underlined-link bbs-pickup-review">Review local pickup requirements</button>
    `;
    wrapper.innerHTML = wrapper.innerHTML.replaceAll('\u00c2\u00b7', '|');
    return wrapper;
  }

  function injectCartAssurance() {
    const cartFooter = document.querySelector('#main-cart-footer .cart__footer, .cart__footer');
    if (cartFooter && !cartFooter.querySelector('.bbs-cart-assurance')) {
      cartFooter.prepend(cartAssuranceMarkup());
    }

    const drawerFooter = document.querySelector('cart-drawer .drawer__footer, #CartDrawer .drawer__footer');
    if (drawerFooter && !drawerFooter.querySelector('.bbs-cart-assurance')) {
      drawerFooter.prepend(cartAssuranceMarkup());
    }
  }

  let modalTrigger = null;
  let selectedDelivery = '';

  function getCheckoutModal() {
    let modal = document.querySelector('.bbs-checkout-modal');
    if (modal) return modal;

    modal = createElement('div', 'bbs-checkout-modal');
    modal.hidden = true;
    modal.innerHTML = `
      <div class="bbs-checkout-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="bbs-delivery-title" aria-describedby="bbs-delivery-description">
        <p class="bbs-checkout-modal__eyebrow">Before checkout</p>
        <h2 id="bbs-delivery-title">How will you get your order?</h2>
        <p id="bbs-delivery-description" class="bbs-checkout-modal__lead">Choose shipping or local pickup so we can prepare your order correctly.</p>
        <div class="bbs-delivery-choice">
          <button type="button" class="bbs-delivery-choice__button" data-bbs-delivery="Shipping" aria-pressed="false">
            <strong>Ship my order</strong>
            <span>Available delivery options and rates will appear at checkout.</span>
          </button>
          <button type="button" class="bbs-delivery-choice__button" data-bbs-delivery="RGV Local Pickup" aria-pressed="false">
            <strong>RGV local pickup</strong>
            <span>Pickup in Donna, Texas after you receive a ready notification.</span>
          </button>
        </div>
        <div class="bbs-pickup-agreement" hidden>
          <p class="bbs-pickup-agreement__warning">YOU MUST BE LOCAL TO THE RGV AREA.</p>
          <label>
            <input type="checkbox" data-bbs-pickup-agree>
            <span>I confirm that I am in the Rio Grande Valley area, can pick up this order in Donna, Texas, and will wait for the ready notification before arriving.</span>
          </label>
        </div>
        <div class="bbs-checkout-modal__actions">
          <button type="button" class="button button--primary" data-bbs-checkout-continue disabled>Continue to checkout</button>
          <button type="button" class="bbs-checkout-modal__cancel" data-bbs-checkout-cancel>Return to cart</button>
        </div>
      </div>
    `;
    document.body.append(modal);

    const choices = [...modal.querySelectorAll('[data-bbs-delivery]')];
    const agreement = modal.querySelector('.bbs-pickup-agreement');
    const checkbox = modal.querySelector('[data-bbs-pickup-agree]');
    const continueButton = modal.querySelector('[data-bbs-checkout-continue]');

    const syncContinue = () => {
      continueButton.disabled = !selectedDelivery || (selectedDelivery === 'RGV Local Pickup' && !checkbox.checked);
    };

    choices.forEach((choice) => {
      choice.addEventListener('click', () => {
        selectedDelivery = choice.dataset.bbsDelivery;
        choices.forEach((button) => button.setAttribute('aria-pressed', String(button === choice)));
        agreement.hidden = selectedDelivery !== 'RGV Local Pickup';
        if (agreement.hidden) checkbox.checked = false;
        syncContinue();
        if (!agreement.hidden) checkbox.focus();
      });
    });
    checkbox.addEventListener('change', syncContinue);
    modal.querySelector('[data-bbs-checkout-cancel]').addEventListener('click', closeCheckoutModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeCheckoutModal();
    });
    continueButton.addEventListener('click', async () => {
      if (continueButton.disabled) return;
      continueButton.disabled = true;
      continueButton.textContent = 'Continuing...';
      const preference = selectedDelivery === 'RGV Local Pickup'
        ? 'RGV Local Pickup - Customer confirmed eligibility'
        : 'Shipping';
      try {
        await fetch(window.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Delivery preference': preference } }),
        });
      } finally {
        const checkout = modalTrigger?.matches?.('button[name="checkout"], input[name="checkout"], .cart__checkout-button')
          ? modalTrigger
          : document.querySelector('button[name="checkout"], input[name="checkout"], .cart__checkout-button');
        closeCheckoutModal();
        if (checkout) {
          checkout.dataset.bbsDeliveryConfirmed = 'true';
          checkout.click();
        } else {
          window.location.assign('/checkout');
        }
      }
    });
    return modal;
  }

  function openCheckoutModal(trigger, pickupFirst = false) {
    modalTrigger = trigger || document.activeElement;
    selectedDelivery = '';
    const modal = getCheckoutModal();
    modal.hidden = false;
    document.body.classList.add('bbs-modal-open');
    const choices = [...modal.querySelectorAll('[data-bbs-delivery]')];
    const checkbox = modal.querySelector('[data-bbs-pickup-agree]');
    const agreement = modal.querySelector('.bbs-pickup-agreement');
    const continueButton = modal.querySelector('[data-bbs-checkout-continue]');
    checkbox.checked = false;
    continueButton.disabled = true;
    continueButton.textContent = 'Continue to checkout';
    choices.forEach((button) => button.setAttribute('aria-pressed', 'false'));
    agreement.hidden = true;
    if (pickupFirst) choices.find((button) => button.dataset.bbsDelivery === 'RGV Local Pickup')?.click();
    else choices[0]?.focus();
  }

  function closeCheckoutModal() {
    const modal = document.querySelector('.bbs-checkout-modal');
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('bbs-modal-open');
    modalTrigger?.focus?.();
  }

  function interceptCheckout() {
    document.addEventListener('click', (event) => {
      const review = event.target.closest('.bbs-pickup-review');
      if (review) {
        event.preventDefault();
        openCheckoutModal(review, true);
        return;
      }

      const checkout = event.target.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button');
      if (!checkout || !checkout.closest('form[action*="/cart"], cart-drawer, #CartDrawer, .cart__footer')) return;
      if (checkout.dataset.bbsDeliveryConfirmed === 'true') {
        delete checkout.dataset.bbsDeliveryConfirmed;
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      openCheckoutModal(checkout);
    }, true);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !document.querySelector('.bbs-checkout-modal')?.hidden) closeCheckoutModal();
    });
  }

  onReady(() => {
    addPageClass();
    addHomeProofStrip();
    addProductAssurance();
    addStickyAddToCart();
    enhanceFitmentCenter();
    addCollectionCategoryBar();
    injectCartAssurance();
    interceptCheckout();

    let cartEnhancementQueued = false;
    new MutationObserver(() => {
      if (cartEnhancementQueued) return;
      cartEnhancementQueued = true;
      window.requestAnimationFrame(() => {
        injectCartAssurance();
        cartEnhancementQueued = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();

/* BEGIN BBS STOREFRONT CLEANUP 2026-08-22 */
(() => {
  'use strict';

  const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function make(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  }

  function addInfernoSpecStrip() {
    if (!currentPath.startsWith('/products/')) return;
    const title = document.querySelector('.product__title h1')?.textContent || '';
    if (!/inferno\s*65cxn/i.test(title) || document.querySelector('.bbs-product-specs, .bbs-buying-guide')) return;

    const priceAnchor = document.querySelector('.product__info-container [id^="price-"], .product__info-container .price');
    const addButton = document.querySelector('.product-form__submit');
    if (!priceAnchor) return;

    const strip = make('section', 'bbs-product-specs');
    strip.setAttribute('aria-label', 'Key Inferno specifications');
    ['250W RMS', '146 mm cutout', 'Sold as a pair', addButton && !addButton.disabled ? 'In stock' : 'Check availability']
      .forEach((label) => strip.append(make('div', 'bbs-product-specs__item', label)));
    priceAnchor.after(strip);
  }

  function inferCardLabels(title) {
    const labels = [];
    const platform = title.match(/Apache\s+(1800|2800|3800|4800)/i)
      || title.match(/\b(1800|2800|3800|4800)\b/);
    const vault = title.match(/Vault\s+V(100|300)/i);
    if (platform) labels.push('Apache ' + platform[1]);
    else if (vault) labels.push('Vault V' + vault[1]);
    else if (/Nexus/i.test(title)) labels.push('Nexus');

    const sizes = [
      [/\b6(?:\.5|-5)\b/i, '6.5-inch'],
      [/\b6x9\b/i, '6x9-inch'],
      [/\b5\.25\b/i, '5.25-inch'],
      [/\b8(?:-inch|")/i, '8-inch'],
      [/\b4(?:-inch|")/i, '4-inch']
    ];
    const size = sizes.find(([pattern]) => pattern.test(title));
    if (size) labels.push(size[1]);

    const types = [
      [/faceplate/i, 'Faceplate'],
      [/spacer/i, 'Spacer'],
      [/grill/i, 'Grille'],
      [/panel/i, 'Panel']
    ];
    const type = types.find(([pattern]) => pattern.test(title));
    if (type) labels.push(type[1]);
    return [...new Set(labels)].slice(0, 3);
  }

  function addCollectionCardChips(root = document) {
    if (!currentPath.startsWith('/collections/')) return;
    root.querySelectorAll('.card-wrapper').forEach((card) => {
      if (card.querySelector('.bbs-product-chips')) return;
      const heading = card.querySelector('.card__heading');
      const title = heading?.textContent?.trim();
      if (!heading || !title) return;
      const labels = inferCardLabels(title);
      if (!labels.length) return;
      const chips = make('div', 'bbs-product-chips');
      chips.setAttribute('aria-label', 'Product fitment summary');
      labels.forEach((label) => chips.append(make('span', 'bbs-product-chip', label)));
      heading.after(chips);
    });
  }

  function addLedCategoryShortcut() {
    document.querySelectorAll('.bbs-category-bar__links').forEach((links) => {
      if (links.querySelector('a[href*="bbs-5v-24v-led-kit"]')) return;
      const led = make('a', '', 'LED lighting');
      led.href = '/products/bbs-5v-24v-led-kit-app-%F0%9F%98%88';
      const spacer = [...links.querySelectorAll('a')].find((link) => /spacers/i.test(link.textContent));
      links.insertBefore(led, spacer || null);
    });
  }

  function compactCartAssurance(root = document) {
    root.querySelectorAll('.bbs-cart-assurance:not([data-bbs-compact])').forEach((box) => {
      box.dataset.bbsCompact = 'true';
      box.querySelector(':scope > strong')?.remove();
      const details = make('details');
      const summary = make('summary', '', 'RGV local pickup available');
      const body = make('div', 'bbs-cart-assurance__details');
      while (box.firstChild) body.append(box.firstChild);
      details.append(summary, body);
      box.append(details);
    });
  }

  function moveFitmentFinderFirst() {
    if (currentPath !== '/pages/fitment-center') return;
    const root = document.querySelector('#MainContent .rte');
    const finder = root?.querySelector('.bbs-fitment-tool');
    if (root && finder && root.firstElementChild !== finder) root.prepend(finder);
  }

  function formatPrice(cents) {
    if (!Number.isFinite(cents)) return '';
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  }

  async function enrichFitmentLink(link) {
    if (link.dataset.bbsEnriched) return;
    link.dataset.bbsEnriched = 'loading';
    const title = link.textContent.trim();
    let product = null;
    try {
      const base = link.getAttribute('href').split('?')[0].replace(/\/$/, '');
      const response = await fetch(base + '.js', { headers: { Accept: 'application/json' } });
      if (response.ok) product = await response.json();
    } catch (_) {
      product = null;
    }

    link.replaceChildren();
    link.classList.add('bbs-fitment-result-card');

    const media = make('span', 'bbs-fitment-result-card__media');
    if (product?.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image;
      image.alt = '';
      image.loading = 'lazy';
      media.append(image);
    }

    const body = make('span', 'bbs-fitment-result-card__body');
    body.append(make('span', 'bbs-fitment-result-card__eyebrow', link.dataset.bbsMatchLabel || 'Check measurements'));
    body.append(make('strong', 'bbs-fitment-result-card__title', title));
    if (link.dataset.bbsFitDetail) body.append(make('span', 'bbs-fitment-result-card__detail', link.dataset.bbsFitDetail));
    const meta = make('span', 'bbs-fitment-result-card__meta');
    const price = formatPrice(product?.price);
    if (price) meta.append(make('span', '', price));
    meta.append(make('span', 'bbs-fitment-result-card__cta', 'View part →'));
    body.append(meta);
    link.append(media, body);
    link.dataset.bbsEnriched = 'true';
  }

  function enrichFitmentResults(root = document) {
    if (currentPath !== '/pages/fitment-center') return;
    root.querySelectorAll('.bbs-fitment-results__list a[href*="/products/"]').forEach(enrichFitmentLink);
  }

  function runEnhancements(root = document) {
    addInfernoSpecStrip();
    addCollectionCardChips(root);
    addLedCategoryShortcut();
    compactCartAssurance(root);
    moveFitmentFinderFirst();
    enrichFitmentResults(root);
  }

  ready(() => {
    runEnhancements();

    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        runEnhancements();
        queued = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
/* END BBS STOREFRONT CLEANUP 2026-08-22 */


/* BEGIN BBS TESTIMONIAL QUALITY FILTER 2026-08-22 */
(() => {
  'use strict';

  function filterPunctuationOnlyTestimonials(root = document) {
    root.querySelectorAll('.jdgm-testimonial').forEach((card) => {
      const reviewText = card.querySelector('.jdgm-text')?.textContent?.trim() || '';
      const punctuationOnly = !reviewText || /^[\s.,!?\-–—]+$/.test(reviewText);
      card.hidden = punctuationOnly;
      if (punctuationOnly) card.setAttribute('aria-hidden', 'true');
      else card.removeAttribute('aria-hidden');
    });
  }

  function start() {
    filterPunctuationOnlyTestimonials();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        filterPunctuationOnlyTestimonials();
        queued = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
/* END BBS TESTIMONIAL QUALITY FILTER 2026-08-22 */

(() => {
  'use strict';

  function enhanceAddons(root = document) {
    const panel = root.querySelector('#bcpo');
    if (!panel || panel.dataset.bbsPremium === 'true') return;
    panel.dataset.bbsPremium = 'true';

    const inputs = [...panel.querySelectorAll('.bcpo-checkboxes input[type="checkbox"]')];
    const noAddons = inputs.find((input) => /^no add[ -]?ons$/i.test(input.value.trim()));
    panel.querySelector('.bcpo-checkboxes')?.style.setProperty('display', 'grid', 'important');

    inputs.forEach((input) => {
      const price = Number(input.dataset.price || 0);
      const label = input.closest('label');
      if (label && !label.dataset.bbsCopyCleaned) {
        [...label.childNodes].forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            node.textContent = node.textContent
              .replace('RGB COBB LED + APP CONTROLL', 'RGB COB LED + APP CONTROL');
          }
        });
        label.dataset.bbsCopyCleaned = 'true';
      }

      if (price > 0 && label && !label.querySelector('.bbs-addon-price')) {
        const badge = document.createElement('span');
        badge.className = 'bbs-addon-price';
        badge.textContent = `+$${price.toFixed(0)}`;
        label.append(badge);
      }

      input.addEventListener('change', () => {
        if (!input.checked || !noAddons) return;
        if (input === noAddons) {
          inputs.filter((candidate) => candidate !== noAddons).forEach((candidate) => {
            candidate.checked = false;
            candidate.dispatchEvent(new Event('change', { bubbles: true }));
          });
        } else if (noAddons.checked) {
          noAddons.checked = false;
          noAddons.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  function start() {
    enhanceAddons();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        enhanceAddons();
        queued = false;
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

(() => {
  'use strict';
  const data = JSON.parse(document.getElementById('bbs-shopping-data')?.textContent || '{}');
  const copy = data.labels || {};
  const palette = {Black:'#191919',White:'#fafafa',Gray:'#808080',Red:'#e33232',Blue:'#235bc4',Green:'#24a04b',Yellow:'#f5d542',Orange:'#f08a24',Purple:'#8142b8',Pink:'#e86aa5',Brown:'#79513c',Tan:'#c4a87d',Silver:'#b8bdc4',Gold:'#c6a443',Transparent:'#e8e8e8'};
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD'}).format(value / 100);
  function setupColors() {
    const panel = document.querySelector('#bcpo');
    if (!panel) return;
    panel.querySelectorAll('select[name^="properties["]').forEach(select => {
      if (!/color|colour/i.test(select.name) || select.dataset.bbsSwatches) return;
      select.dataset.bbsSwatches = 'true';
      const group = document.createElement('div');
      group.className = 'bbs-color-options';
      group.setAttribute('role','group');
      group.setAttribute('aria-label',select.name.replace(/^properties\[|\]$/g,''));
      const description = document.createElement('p');
      description.className = 'bbs-color-help';
      description.textContent = copy.color_help;
      const buttons = [];
      [...select.options].filter(option => option.value && !option.disabled).forEach(option => {
        const colorName = option.value.trim();
        const extra = Number(option.dataset.price || 0);
        const priceLabel = extra ? `+${money(Math.round(extra*100))}` : copy.included_price;
        option.textContent = `${colorName} — ${priceLabel}`;
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'bbs-color-option';
        const swatch = document.createElement('span');
        swatch.className = 'bbs-color-swatch'; swatch.setAttribute('aria-hidden','true');
        swatch.style.backgroundColor = palette[colorName] || '#888';
        const label = document.createElement('span'); label.textContent = `${colorName} · ${priceLabel}`;
        button.append(swatch,label); button.dataset.value = option.value;
        button.addEventListener('click',()=> {select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));});
        group.append(button);buttons.push(button);
      });
      const sync = () => buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.value===select.value)));
      select.addEventListener('change',sync); sync();
      select.parentElement.after(description,group);
    });
    updatePrice();
  }
  function updatePrice() {
    const panel = document.querySelector('#bcpo');
    if (!panel || !data.product) return;
    const form = document.querySelector('product-form form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    const base = data.product.variants.find(variant=>String(variant.id)===variantId)?.price ?? data.product.price;
    let extras = 0;
    panel.querySelectorAll('select[name^="properties["]').forEach(select=>{extras += Number(select.selectedOptions[0]?.dataset.price || 0);});
    panel.querySelectorAll('input:checked[data-price]').forEach(input=>{extras += Number(input.dataset.price || 0);});
    let total = panel.querySelector('.bbs-configured-price');
    if (!total) {
      total=document.createElement('div');total.className='bbs-configured-price';total.setAttribute('role','status');total.setAttribute('aria-live','polite');panel.append(total);
    }
    const text = `${copy.unit_total}: ${money(base+Math.round(extras*100))} (${copy.base}: ${money(base)} · ${copy.extras}: ${money(Math.round(extras*100))})`;
    if(total.textContent!==text) total.textContent=text;
    panel.querySelector('.bcpo-price-addons')?.setAttribute('hidden','');
    const stickyPrice=document.querySelector('.bbs-sticky-atc__price');
    if(stickyPrice && stickyPrice.textContent!==money(base+Math.round(extras*100))) stickyPrice.textContent=money(base+Math.round(extras*100));
  }
  function setupStickyValidation() {
    const sticky=document.querySelector('.bbs-sticky-atc__button');
    if(!sticky || sticky.dataset.bbsValidation) return;
    sticky.dataset.bbsValidation='true';
    sticky.addEventListener('click',event=>{
      const invalid=[...document.querySelectorAll('#bcpo select[required], #bcpo input[required]')].find(field=>!field.checkValidity());
      if(!invalid) return;
      event.preventDefault();event.stopImmediatePropagation();
      invalid.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      invalid.focus({preventScroll:true});invalid.reportValidity();
    },true);
  }
  function run() {setupColors();setupStickyValidation();}
  function start() {
    run();
    document.addEventListener('change',event=>{if(event.target.closest('#bcpo, product-info')) updatePrice();});
    let queued=false;
    new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;run();});}).observe(document.querySelector('product-info') || document.getElementById('MainContent'),{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();


